<mat-form-field class="time-picker__field" appearance="outline" floatLabel="always" cdkOverlayOrigin #timePickerOrigin="cdkOverlayOrigin">
  <mat-label>{{ label | translate }}</mat-label>
  <input matInput readonly required role="combobox" aria-haspopup="dialog" [value]="displayValue"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="isOpen ? pickerId + '-picker' : null"
    (click)="openPicker()"
    (keydown.enter)="$event.preventDefault(); openPicker()"
    (keydown.space)="$event.preventDefault(); openPicker()"
    (keydown.arrowdown)="$event.preventDefault(); openPicker()">
  <span matIconSuffix class="time-picker__actions">
    @if (showNowButton) {
      <button mat-button class="time-picker__shortcut" type="button" (click)="nowClicked.emit()">
        {{ "open_job_detail_now" | translate }}
      </button>
    }
    <button mat-icon-button type="button" (click)="openPicker()"
      [attr.aria-label]="label | translate"><mat-icon>schedule</mat-icon></button>
  </span>
  @if (showError && errorMessage) {
    <mat-error>{{ errorMessage | translate }}</mat-error>
  }
</mat-form-field>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="timePickerOrigin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12"
  (backdropClick)="closePicker()"
  (overlayKeydown)="$event.key === 'Escape' && closePicker()">
  <section class="time-picker__panel" role="dialog" [id]="pickerId + '-picker'"
    [attr.aria-label]="label | translate" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="time-picker__columns">
      <label>
        <span>{{ "open_job_detail_hours" | translate }}</span>
        <select size="5" #hoursList (change)="draftHours = hoursList.value" cdkFocusInitial>
          @for (hour of hours; track hour) {
            <option [value]="hour" [selected]="hour === draftHours">{{ hour }}</option>
          }
        </select>
      </label>
      <label>
        <span>{{ "open_job_detail_minutes" | translate }}</span>
        <select size="5" #minutesList (change)="draftMinutes = minutesList.value">
          @for (minute of minuteOptions; track minute) {
            <option [value]="minute" [selected]="minute === draftMinutes">{{ minute }}</option>
          }
        </select>
      </label>
    </div>
    <div class="time-picker__panel-actions">
      <button mat-button type="button" (click)="clearPicker()">{{ "open_job_detail_clear" | translate }}</button>
      <button mat-flat-button class="time-picker__done" type="button" (click)="confirmPicker()">
        {{ "open_job_detail_done" | translate }}
      </button>
    </div>
  </section>
</ng-template>
